import api from '../../services/api';

export default {
    namespaced: true,
    state: {
        items: [],
        availableConnectors: [],
        connector: {},
        current: null,
        errors: null
    },
    actions: {
        retrieveConnectors ({ commit }, { instanceId, services }) {
            const additional = {};
            if (services) additional.services = services;

            api.data.list(instanceId, 'adapter', 1, 1, additional, result => {
                commit('setItems', result);
            });
        },
        retrieveAvailableConnectors ({ commit }, {  }) {
            api.connectors.listAvailableConnectors(result => {
                commit('setAvailableConnectors', result);
            })
        },
        getAvailableConnector ({ commit }, { id }) {
            api.connectors.getAvailableConnector(id, result => {
                commit('setConnector', result);
            })
        },
        retrieveConnectorDetails ({ commit }, { instanceId, connectorId }) {
            return new Promise((resolve) => {
                const otherServices = ['engine'];
                if (!otherServices.includes(connectorId)) {
                    api.data.get(instanceId, `adapter/${connectorId}`, result => {
                        commit('setCurrent', result);
                        resolve(result);
                    });
                } else {
                    const result = {
                        id:             connectorId,
                        identifier:     connectorId.ucfirst(),
                        not_an_connector: true,
                    };

                    commit('setCurrent', result);
                    resolve(result);
                }
            });
        },
        retrieveConnectorSettings (context, { instanceId, connectorId }) {
            return new Promise((resolve) => {
                const otherServices = ['engine'];
                if (!otherServices.includes(connectorId)) {
                    api.data.get(instanceId, `adapter/${connectorId}/settings`, result => {
                        resolve(result);
                    });
                } else {
                    switch (connectorId) {
                        case 'engine':
                            api.data.get(instanceId, `engine/settings`, result => {
                                resolve(result);
                            });
                            break;
                        default:
                            throw new Error('Unknown connector');
                    }
                }
            });
        },
        updateConnectorSettings (context, { instanceId, connectorId, settings }) {
            return new Promise((resolve) => {
                const otherServices = ['engine'];
                if (!otherServices.includes(connectorId)) {
                    api.data.put(instanceId, `adapter/${connectorId}/settings`, { settings }, result => {
                        resolve(result);
                    });
                } else {
                    switch (connectorId) {
                        case 'engine':
                            api.data.put(instanceId, `engine/settings`, { settings }, result => {
                                resolve(result);
                            });
                            break;
                        default:
                            throw new Error('Unknown connector');
                    }
                }
            });
        },
        createConnector ({ dispatch, commit }, { instanceId, connector }) {
            return new Promise((resolve) => {
                api.data.post(instanceId, `connector`, connector, result => {
                    dispatch('notifications/queueNotification', 'Successfully started the installation of the connector', { root: true });
                    resolve(result);
                }, (error) => {
                    commit('setErrors', error.response.data.errors);
                });
            });
        },
        getJobStatus ({ dispatch, commit }, { instanceId, identifier }) {
            return new Promise((resolve) => {
                api.data.get(instanceId, `connector/${identifier}/status`, result => {
                    resolve(result);
                }, (error) => {
                    commit('setErrors', error.response.data.errors);
                });
            });
        },
        updateConnector (context, { instanceId, connector }) {
            return new Promise((resolve) => {
                api.data.put(instanceId, `adapter/${connector.id}`, connector, result => {
                    resolve(result);
                });
            });
        },
    },
    mutations: {
        setItems (state, connectors) {
            state.items = connectors;
        },
        setCurrent (state, connector) {
            state.current = connector;
        },
        setErrors (state, errors) {
            state.errors = errors;
        },
        setAvailableConnectors (state, connectors) {
            state.availableConnectors = connectors;
        },
        setConnector (state, connector) {
            state.connector = connector;
        },
        clearConnector (state) {
            state.connector = {};
        },
    }
};
